// cookieconsent is a legacy global library that doesn't work with Vite/ESM
// Commenting out for now - can be loaded via <script> tag if needed
// import 'cookieconsent/build/cookieconsent.min.js';

if (window.cookieConsentValues && window.cookieconsent) {
  document.addEventListener('DOMContentLoaded', () => {
    window.cookieconsent.initialise({
      content: {
        message: window.cookieConsentValues.text,
        dismiss: window.cookieConsentValues.dismissButtonText,
        allow: window.cookieConsentValues.allowButtonText,
        href: window.cookieConsentValues.disclaimerUrl,
        link: window.cookieConsentValues.disclaimerLabel,
      },
      showLink: !!window.cookieConsentValues.disclaimerUrl,
      type: (window.cookieConsentValues.optInOrOut && window.cookieConsentValues.optInOrOut) || null,
    });
  });
}
